import React from 'react'
import { Row, Col } from 'react-bootstrap'

const Main = ({ children }) => {
    return (
        <Col
            xs={{ span: 12, order: 2 }}
            lg={{ span: 8, order: 1 }}
            style={{ padding: '20px'}}
        >
            {children}
        </Col>
    )
}

const Bar = ({ children }) => {
    return (
        <Col sm={{ span: 12, order: 1 }} lg={{ span: 4, order: 2 }} style={{ borderLeft: '2px solid rgb(243, 250, 255)', height: '100%' }}>
            {children}
        </Col>
    )
}

const FullSplitTemplate = ({ children }) => {
    return (
        <Row>{children}</Row>
    )
}

FullSplitTemplate.Main = Main
FullSplitTemplate.Bar = Bar

export default FullSplitTemplate